// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tape Panel Styles - CSS Module */
.wGTm78W90BiUFacFiE6n {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 240px;
  z-index: var(--vnsc-z-dock, 51);
  background: var(--vnsc-bg-primary);
  border-left: 1px solid var(--vnsc-border-primary);
  display: flex;
  flex-direction: column;
  font-size: var(--vnsc-font-size-xs);
  color: var(--vnsc-text-primary);
  overflow: hidden;
}

.K4Wgjlc8suwryZ2Tiroy {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--vnsc-space-2);
  border-bottom: 1px solid var(--vnsc-border-divider);
  background: var(--vnsc-bg-secondary);
  flex-shrink: 0;
}

.WemVgCUtyr5y_7ppLwF1 {
  font-weight: 700;
  font-size: var(--vnsc-font-size-sm);
}

.tkSHmbwX5vuJap01wG8A {
  background: none;
  border: none;
  color: var(--vnsc-text-secondary);
  cursor: pointer;
  font-size: var(--vnsc-font-size-md);
  padding: 0 4px;
  transition: color 0.15s ease;
}

.tkSHmbwX5vuJap01wG8A:hover {
  color: var(--vnsc-text-primary);
}

.WsamFZWIOWQN3EgmSFi6 {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-bottom: 1px solid var(--vnsc-border-divider);
  flex-shrink: 0;
}

.PWG8aIMbYESj_87SXqoi {
  color: var(--vnsc-text-secondary);
  white-space: nowrap;
}

.yF88LrJoQcZ5EXhtABNd {
  flex: 1;
  cursor: pointer;
}

.UMarm9KztrCuWzOCCMva {
  width: 38px;
  text-align: right;
  color: var(--vnsc-text-primary);
  flex-shrink: 0;
}

.yUattMaASZhyA5hrbaII {
  display: grid;
  grid-template-columns: 52px 70px 52px 44px 22px;
  padding: 2px 4px;
  color: var(--vnsc-text-secondary);
  font-size: var(--vnsc-font-size-2xs);
  border-bottom: 1px solid var(--vnsc-border-divider);
  flex-shrink: 0;
}

.zUCp6wXe6uvx2l4CzFuj {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.H5PAvNzU6c08m164gbAe,
.ZXzrbUdnhBVhGmXyktqK {
  text-align: center;
  color: var(--vnsc-text-secondary);
  padding-top: 20px;
}

.Rv1xh8gl7aie_EsPFZMv {
  display: grid;
  grid-template-columns: 52px 70px 52px 44px 22px;
  height: 22px;
  align-items: center;
  padding: 0 4px;
  background: transparent;
  border-bottom: 1px solid var(--vnsc-border-divider);
}

.GG4J8PN5JJHVz5ZqEs8I {
  background: color-mix(in srgb, var(--vnsc-color-warning) 15%, transparent);
  border-bottom: 1px solid color-mix(in srgb, var(--vnsc-color-warning) 60%, transparent);
}

.Balr__mcRrop_BaW9ynG {
  color: var(--vnsc-text-secondary);
  font-size: var(--vnsc-font-size-2xs);
}

.IxyM_mIsQ9yWeFGpNcqg {
  text-align: right;
  font-weight: 400;
}

.tHFZofiGgqVc2c218RrG {
  color: var(--vnsc-color-bullish);
}

.H4aw97ocY5OfdfIgt1Ln {
  color: var(--vnsc-color-bearish);
}

.nol1LodQbMbMxpj4x_yB {
  font-weight: 700;
}

.SjlQJJtIesFNKhwXujJC {
  text-align: right;
  color: var(--vnsc-text-secondary);
}

.gGESdJG0uMMzdbD4BU9a {
  text-align: right;
  color: var(--vnsc-text-secondary);
}

.BZTfkUAw0Wf5nv1SwNY1 {
  color: var(--vnsc-color-warning);
}

.ddTDAY_2Bz8agNFkPzXv {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 14px;
  width: 16px;
  border-radius: 2px;
  font-size: var(--vnsc-font-size-2xs);
  font-weight: 700;
}

._X8IbSHxQBDhhuMAe2Hw {
  background: color-mix(in srgb, var(--vnsc-color-bullish) 35%, transparent);
  color: var(--vnsc-text-on-primary);
}

.UwiYCZklVz200S8eImp9 {
  background: var(--vnsc-color-bearish);
  color: var(--vnsc-text-on-primary);
}

.L5HhpfW6eNUfZkJKZtlg {
  background: color-mix(in srgb, var(--vnsc-text-secondary) 30%, transparent);
  color: var(--vnsc-text-primary);
}

.O330S5qhOGzzjXLGmiqJ {
  padding: 4px 8px;
  border-top: 1px solid var(--vnsc-border-divider);
  color: var(--vnsc-text-secondary);
  font-size: var(--vnsc-font-size-2xs);
  flex-shrink: 0;
}

@media (max-width: 480px) {
  .wGTm78W90BiUFacFiE6n {
    width: 100%;
    height: auto;
    max-height: 40%;
    bottom: 0;
    top: auto;
    right: 0;
    border-left: none;
    border-top: 1px solid var(--vnsc-border-primary);
  }
}`, "",{"version":3,"sources":["webpack://./src/widget/styles/tape-panel.module.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,+BAA+B;EAC/B,kCAAkC;EAClC,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,mDAAmD;EACnD,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,mCAAmC;EACnC,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mDAAmD;EACnD,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,gBAAgB;EAChB,iCAAiC;EACjC,oCAAoC;EACpC,mDAAmD;EACnD,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,mDAAmD;AACrD;;AAEA;EACE,0EAA0E;EAC1E,uFAAuF;AACzF;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,0EAA0E;EAC1E,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,2EAA2E;EAC3E,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,iCAAiC;EACjC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,SAAS;IACT,SAAS;IACT,QAAQ;IACR,iBAAiB;IACjB,gDAAgD;EAClD;AACF","sourcesContent":["/* Tape Panel Styles - CSS Module */\r\n.panel {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  width: 240px;\r\n  z-index: var(--vnsc-z-dock, 51);\r\n  background: var(--vnsc-bg-primary);\r\n  border-left: 1px solid var(--vnsc-border-primary);\r\n  display: flex;\r\n  flex-direction: column;\r\n  font-size: var(--vnsc-font-size-xs);\r\n  color: var(--vnsc-text-primary);\r\n  overflow: hidden;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: var(--vnsc-space-2);\r\n  border-bottom: 1px solid var(--vnsc-border-divider);\r\n  background: var(--vnsc-bg-secondary);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.title {\r\n  font-weight: 700;\r\n  font-size: var(--vnsc-font-size-sm);\r\n}\r\n\r\n.closeBtn {\r\n  background: none;\r\n  border: none;\r\n  color: var(--vnsc-text-secondary);\r\n  cursor: pointer;\r\n  font-size: var(--vnsc-font-size-md);\r\n  padding: 0 4px;\r\n  transition: color 0.15s ease;\r\n}\r\n\r\n.closeBtn:hover {\r\n  color: var(--vnsc-text-primary);\r\n}\r\n\r\n.filterBar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 4px 8px;\r\n  border-bottom: 1px solid var(--vnsc-border-divider);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.filterLabel {\r\n  color: var(--vnsc-text-secondary);\r\n  white-space: nowrap;\r\n}\r\n\r\n.filterSlider {\r\n  flex: 1;\r\n  cursor: pointer;\r\n}\r\n\r\n.filterValue {\r\n  width: 38px;\r\n  text-align: right;\r\n  color: var(--vnsc-text-primary);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.columnHeaders {\r\n  display: grid;\r\n  grid-template-columns: 52px 70px 52px 44px 22px;\r\n  padding: 2px 4px;\r\n  color: var(--vnsc-text-secondary);\r\n  font-size: var(--vnsc-font-size-2xs);\r\n  border-bottom: 1px solid var(--vnsc-border-divider);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.entriesList {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.loading,\r\n.empty {\r\n  text-align: center;\r\n  color: var(--vnsc-text-secondary);\r\n  padding-top: 20px;\r\n}\r\n\r\n.row {\r\n  display: grid;\r\n  grid-template-columns: 52px 70px 52px 44px 22px;\r\n  height: 22px;\r\n  align-items: center;\r\n  padding: 0 4px;\r\n  background: transparent;\r\n  border-bottom: 1px solid var(--vnsc-border-divider);\r\n}\r\n\r\n.rowWhale {\r\n  background: color-mix(in srgb, var(--vnsc-color-warning) 15%, transparent);\r\n  border-bottom: 1px solid color-mix(in srgb, var(--vnsc-color-warning) 60%, transparent);\r\n}\r\n\r\n.rowTime {\r\n  color: var(--vnsc-text-secondary);\r\n  font-size: var(--vnsc-font-size-2xs);\r\n}\r\n\r\n.rowPrice {\r\n  text-align: right;\r\n  font-weight: 400;\r\n}\r\n\r\n.rowPriceBuy {\r\n  color: var(--vnsc-color-bullish);\r\n}\r\n\r\n.rowPriceSell {\r\n  color: var(--vnsc-color-bearish);\r\n}\r\n\r\n.rowPriceWhale {\r\n  font-weight: 700;\r\n}\r\n\r\n.rowVolume {\r\n  text-align: right;\r\n  color: var(--vnsc-text-secondary);\r\n}\r\n\r\n.rowValue {\r\n  text-align: right;\r\n  color: var(--vnsc-text-secondary);\r\n}\r\n\r\n.rowValueWhale {\r\n  color: var(--vnsc-color-warning);\r\n}\r\n\r\n.rowSide {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 14px;\r\n  width: 16px;\r\n  border-radius: 2px;\r\n  font-size: var(--vnsc-font-size-2xs);\r\n  font-weight: 700;\r\n}\r\n\r\n.rowSideBuy {\r\n  background: color-mix(in srgb, var(--vnsc-color-bullish) 35%, transparent);\r\n  color: var(--vnsc-text-on-primary);\r\n}\r\n\r\n.rowSideSell {\r\n  background: var(--vnsc-color-bearish);\r\n  color: var(--vnsc-text-on-primary);\r\n}\r\n\r\n.rowSideUnknown {\r\n  background: color-mix(in srgb, var(--vnsc-text-secondary) 30%, transparent);\r\n  color: var(--vnsc-text-primary);\r\n}\r\n\r\n.footer {\r\n  padding: 4px 8px;\r\n  border-top: 1px solid var(--vnsc-border-divider);\r\n  color: var(--vnsc-text-secondary);\r\n  font-size: var(--vnsc-font-size-2xs);\r\n  flex-shrink: 0;\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .panel {\r\n    width: 100%;\r\n    height: auto;\r\n    max-height: 40%;\r\n    bottom: 0;\r\n    top: auto;\r\n    right: 0;\r\n    border-left: none;\r\n    border-top: 1px solid var(--vnsc-border-primary);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `wGTm78W90BiUFacFiE6n`,
	"header": `K4Wgjlc8suwryZ2Tiroy`,
	"title": `WemVgCUtyr5y_7ppLwF1`,
	"closeBtn": `tkSHmbwX5vuJap01wG8A`,
	"filterBar": `WsamFZWIOWQN3EgmSFi6`,
	"filterLabel": `PWG8aIMbYESj_87SXqoi`,
	"filterSlider": `yF88LrJoQcZ5EXhtABNd`,
	"filterValue": `UMarm9KztrCuWzOCCMva`,
	"columnHeaders": `yUattMaASZhyA5hrbaII`,
	"entriesList": `zUCp6wXe6uvx2l4CzFuj`,
	"loading": `H5PAvNzU6c08m164gbAe`,
	"empty": `ZXzrbUdnhBVhGmXyktqK`,
	"row": `Rv1xh8gl7aie_EsPFZMv`,
	"rowWhale": `GG4J8PN5JJHVz5ZqEs8I`,
	"rowTime": `Balr__mcRrop_BaW9ynG`,
	"rowPrice": `IxyM_mIsQ9yWeFGpNcqg`,
	"rowPriceBuy": `tHFZofiGgqVc2c218RrG`,
	"rowPriceSell": `H4aw97ocY5OfdfIgt1Ln`,
	"rowPriceWhale": `nol1LodQbMbMxpj4x_yB`,
	"rowVolume": `SjlQJJtIesFNKhwXujJC`,
	"rowValue": `gGESdJG0uMMzdbD4BU9a`,
	"rowValueWhale": `BZTfkUAw0Wf5nv1SwNY1`,
	"rowSide": `ddTDAY_2Bz8agNFkPzXv`,
	"rowSideBuy": `_X8IbSHxQBDhhuMAe2Hw`,
	"rowSideSell": `UwiYCZklVz200S8eImp9`,
	"rowSideUnknown": `L5HhpfW6eNUfZkJKZtlg`,
	"footer": `O330S5qhOGzzjXLGmiqJ`
};
export default ___CSS_LOADER_EXPORT___;
